import { Injectable } from '@angular/core';
import { GestioneLoginService } from './login/gestione-login.service';
import { CanActivate, ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';

@Injectable({
   providedIn: 'root'
})

export class AuthGuardService implements CanActivate {

   constructor(
      public authService: GestioneLoginService,
      public router: Router) { }

   // ------------------------------------------------------------------------------------------

   /**
    * Per controllare se una rotta può essere attivata prima che l'utente vi acceda.
    * @param route: ActivatedRouteSnapshot → Contiene informazioni sulla rotta attuale, incluso
    *               l'URL e i parametri della query string. 
    * 
    * @param state: RouterStateSnapshot → Rappresenta lo stato attuale del router, incluso l'URL
    *               che si sta tentando di caricare. 
    * Controlla se l'utente è già loggato, se non lo è effettua il redirect alla pagina di login
    */

   // Microsoft Azure AD SSO

   canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
      if (this.authService.userIsLoggedIn()) {
         return true;
      } else {
         sessionStorage.clear();
         this.router.navigate(['login']);
         return false;
      }

   }

}
